export default __webpack_public_path__ + "static/media/480_dummy2016-massagestudio01-de.4d8e3cf6.png";